module.exports = __webpack_public_path__ + "img/loader.d4857d8d.svg";